import { render, staticRenderFns } from "./general-reviews.vue?vue&type=template&id=7a9b3b50&"
import script from "./general-reviews.vue?vue&type=script&lang=js&"
export * from "./general-reviews.vue?vue&type=script&lang=js&"
import style0 from "./general-reviews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports